import React from "react";

interface TypingIndicatorProps {
  who?: string;
}

export function TypingIndicator({ who = "someone" }: TypingIndicatorProps) {
  return (
    <div className="agent-typing-indicator">
      <span className="agent-typing-indicator__text">{who} is typing</span>
      <span className="agent-typing-indicator__dots">
        <span className="agent-typing-indicator__dot" />
        <span className="agent-typing-indicator__dot" />
        <span className="agent-typing-indicator__dot" />
      </span>
    </div>
  );
}
